import React, { useState } from "react";

// external package
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapPin,
  faClock,
  faXmark,
  faArrowTurnDown,
} from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";

// State
import { RootState } from "../../store/authStore";

// Source
import { historyJobSource } from "../../source/historyJobSource";

export default function Index() {
  // state
  const isMobile = useSelector((state: RootState) => state.auth.isMobile);
  const [openDetail, setOpenDetail] = useState<boolean[]>([]);
  const [showExperiences, setShowExperiences] =
    useState<string>("professional");

  // function
  const handleToggleDetail = (index: number) => {
    setOpenDetail((prev) => {
      const newOpenDetail = [...prev];
      newOpenDetail[index] = !newOpenDetail[index];
      return newOpenDetail;
    });
  };
  const handleToggleExperiences = (experiences: string) => {
    setShowExperiences(experiences);
  };
  const filteredExperiences = historyJobSource.filter(
    (item) => item.type === showExperiences
  );
  return (
    <div className="history">
      {isMobile ? (
        <>
          <h1 className="history_title font-size-50 font-vietnam-600">
            Experiences
          </h1>
          <p className="history_description font-size-18 font-vietnam-200">
            This page showcases the various experiences and <br /> projects that
            I have been involved in throughout my career. <br /> Here, you can
            find detailed information about <br /> my professional journey,
            skills, and accomplishments.
          </p>
          <div className="history_content mb-4">
            <div className="row">
              <div className="col-6">
                <button
                  onClick={() => handleToggleExperiences("professional")}
                  className={`btn btn-outline-radius font-vietnam-200 ${
                    showExperiences === "professional" ? "btn-active" : ""
                  }`}
                >
                  Professional
                </button>
              </div>
              <div className="col-6">
                <button
                  onClick={() => handleToggleExperiences("freelance")}
                  className={`btn btn-outline-radius font-vietnam-200 ${
                    showExperiences === "freelance" ? "btn-active" : ""
                  }`}
                >
                  Freelance
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {filteredExperiences.length > 0 ? (
                  filteredExperiences.map((item, index) => (
                    <div key={item.id} className="history_content_job">
                      <div className="row">
                        <div className="col-9">
                          <div className="title w-100">
                            <h2 className="font-size-18 font-vietnam-600">
                              {item.position}{" "}
                              <span className="font-size-14 font-vietnam-300-italic">
                                {item.startDate} - {item.endDate}
                              </span>
                            </h2>
                            <div className="font-size-14 font-vietnam-200 ">
                              {item.company}{" "}
                              <span className="font-size-14 ms-1">
                                ({item.location})
                              </span>
                            </div>
                            <div className="row mt-4">
                              <div className="col-12 d-flex align-items-center gap-2">
                                <div className="site font-size-12 font-vietnam-600">
                                  <FontAwesomeIcon icon={faMapPin} /> 100%{" "}
                                  {item.workType}
                                </div>
                                <div className="position font-size-12 font-vietnam-600">
                                  <FontAwesomeIcon icon={faClock} />{" "}
                                  {item.employmentType}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="description w-100">
                            <div
                              onClick={() => handleToggleDetail(index)}
                              className="title_description d-flex  align-items-center justify-content-end font-size-18 font-vietnam-600 gap-3"
                            >
                              Detail{" "}
                              {openDetail[index] ? (
                                <FontAwesomeIcon icon={faXmark} />
                              ) : (
                                <FontAwesomeIcon icon={faArrowTurnDown} />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          {openDetail[index] && (
                            <div
                              className={`detail_description mt-2 w-100 ${
                                openDetail[index] ? "open_detail" : ""
                              }`}
                            >
                              <ul>
                                {item.listDescription.map((desc) => (
                                  <li key={desc.idDescription}>
                                    {desc.detail}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-5">
                    <p className="font-vietnam-400 font-size-30 lh-1 font-vietnam-600">
                      {showExperiences} projects will be updated soon.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <h1 className="history_title font-size-50 font-vietnam-600">
            Experiences
          </h1>
          <p className="history_description font-size-18 font-vietnam-200">
            This page showcases the various experiences and <br /> projects that
            I have been involved in throughout my career. <br /> Here, you can
            find detailed information about <br /> my professional journey,
            skills, and accomplishments.
          </p>
          <div className="history_content">
            <div className="row">
              <div className="col-3">
                <button
                  onClick={() => handleToggleExperiences("professional")}
                  className={`btn btn-outline-radius font-vietnam-200 ${
                    showExperiences === "professional" ? "btn-active" : ""
                  }`}
                >
                  Professional
                </button>
              </div>
              <div className="col-3">
                <button
                  onClick={() => handleToggleExperiences("freelance")}
                  className={`btn btn-outline-radius font-vietnam-200 ${
                    showExperiences === "freelance" ? "btn-active" : ""
                  }`}
                >
                  Freelance
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {filteredExperiences.length > 0 ? (
                  filteredExperiences.map((item, index) => (
                    <div key={item.id} className="history_content_job">
                      <div className="row">
                        <div className="col-6">
                          <div className="title w-100">
                            <h2 className="font-size-24 font-vietnam-600">
                              {item.position}{" "}
                              <span className="ms-2 font-size-14 font-vietnam-300-italic">
                                {item.startDate} - {item.endDate}
                              </span>
                            </h2>
                            <div className="font-size-18 font-vietnam-200 ">
                              {item.company}{" "}
                              <span className="font-size-14 ms-1">
                                ({item.location})
                              </span>
                            </div>
                            <div className="row mt-4">
                              <div className="col-12 d-flex align-items-center gap-2">
                                <div className="site font-size-16 font-vietnam-600">
                                  <FontAwesomeIcon icon={faMapPin} /> 100%{" "}
                                  {item.workType}
                                </div>
                                <div className="position font-size-16 font-vietnam-600">
                                  <FontAwesomeIcon icon={faClock} />{" "}
                                  {item.employmentType}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="description w-100">
                            <div
                              onClick={() => handleToggleDetail(index)}
                              className="title_description d-flex  align-items-center justify-content-end font-size-18 font-vietnam-600 gap-3"
                            >
                              Detail{" "}
                              {openDetail[index] ? (
                                <FontAwesomeIcon icon={faXmark} />
                              ) : (
                                <FontAwesomeIcon icon={faArrowTurnDown} />
                              )}
                            </div>
                          </div>
                          {openDetail[index] && (
                            <div
                              className={`detail_description mt-2 w-100 ${
                                openDetail[index] ? "open_detail" : ""
                              }`}
                            >
                              <ul>
                                {item.listDescription.map((desc) => (
                                  <li key={desc.idDescription}>
                                    {desc.detail}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-5">
                    <p className="font-vietnam-400 font-size-36 font-vietnam-600">
                      {showExperiences} projects will be updated soon.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
